import { Component, OnInit, ElementRef, ViewChild, Inject, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-dashboard-devices-types-zoom-card',
  templateUrl: './dashboard-devices-types-zoom-card.component.html',
  styleUrls: ['./dashboard-devices-types-zoom-card.component.scss']
})
export class DashboardDevicesTypesZoomCardComponent implements OnInit, AfterViewInit {

  @ViewChild('devicesType', { static: false }) devicesTypeRef: ElementRef;
  ctx;
  chart;
  title;
  colors;

  constructor(@Inject(MAT_DIALOG_DATA) public data,
              private dialogRef: MatDialogRef<MatDialog>) { }

  ngOnInit() {
    this.title = this.data.title;
    this.colors = this.data.colors;
  }

  ngAfterViewInit() {
    this.ctx = this.devicesTypeRef.nativeElement.getContext('2d');
    this.renderChart(this.data.data);
  }

  public close() {
    this.dialogRef.close();
  }

  private renderChart(data) {

    if (this.chart) {
      this.chart.destroy();
    }
    this.chart = new Chart(this.ctx, {
      type: 'bar',
      data: {
        labels: data.map(d => d.label),
        datasets: [
          {
            data: data.map(d => d.nbActiveTrue),
            backgroundColor: this.colors[3],
            hoverBackgroundColor: this.colors[3],
            label: 'ON'
          },
          {
            data: data.map(d => d.nbActiveFalse),
            backgroundColor: this.colors[1],
            hoverBackgroundColor: this.colors[1],
            label: 'OFF'
          },
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            gridLines: {
              display: true,
              color: '#eeeeee',
              drawBorder: false
            },
            ticks: {
              padding: 20,
              fontColor: '#aaaaaa',
              beginAtZero: true,
              stepSize: 1
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              fontColor: '#aaaaaa'
            }
          }]
        },
        legend: {
          display: true,
          position: 'bottom',
          align: 'end',
          fontColor: '#aaaaaa'
        }
      },
      plugins: [{
        id: 'total',
        afterDraw: (chart) => {
          if (!(data.map(d => d.label).length > 0)) {
            const width = chart.width;
            const height = chart.height;
            const ctx = chart.ctx;
            ctx.restore();
            const text1 = 'Not found';
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(width / 2 - ctx.measureText(text1).width / 2 - 30, height / 2 - 65, ctx.measureText(text1).width + 60, 50);
            ctx.fillStyle = '#aaaaaa';
            ctx.font = '14px sans-serif';
            ctx.fillText(text1, width / 2 - (ctx.measureText(text1).width / 2), height / 2 - 40);
            ctx.save();
          }
        }
      }]
    });
  }
}
